module.exports = __webpack_public_path__ + "static/img/lv1.208c12df.png";